import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { BailLineModel } from './bail-line.model';
import { ConceptModel } from '../../concept/concept/concept.model';
import { BailTaxModel } from './bail-tax.model';
import { ConceptService } from '../../concept/concept/concept.service';
import { Observable } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { TaxCalculator } from '../../../shared/taxCalculator';
import { map } from 'rxjs';


@Component({
    selector: 'convfact-bail-form-item',
    templateUrl: './bail-form-item.component.html',
    styleUrls: [],
    standalone: false
})

export class BailFormItemComponent implements OnInit {
  @Input() item = new BailLineModel();
  @Input() taxes = Array<BailTaxModel>();
  @Input() concepts = Array<ConceptModel>();
  chipsArray: [{}];

  conceptCtrl: UntypedFormControl;
  filteredConcepts: Observable<ConceptModel[]>;


  constructor(private conceptService: ConceptService,
    public dialogRef: MatDialogRef<BailFormItemComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private taxCalculator: TaxCalculator,
    public snackBar: MatSnackBar,) { }

  completeData(value: string) {
    alert(value);
  }

  filterConcepts(val) {
    const self = this;
    for (const concept of this.concepts) {
      if (concept.name == val) {
        self.item.quantity = 1;
        self.item.unityAmount = concept.netPrice;
        self.item.taxes = concept.taxes;
        self.item.discount = 0;
      }
    }

    const normalizedValue = this.normalize(val);
    return val ? this.concepts.filter(concept => this.normalize(concept.shortcut).includes(normalizedValue)) : this.concepts;
  }

  // Normaliza la cadena eliminando diacríticos y convirtiéndola a minúsculas
  // NFD Descompone la consonante por ejemplo ñ -> n -> ~
  private normalize(str: string): string {
    return str.normalize('NFD').replace(/[\u0300\u0301\u0303\u0327\u0308]/g, '').toLowerCase();
  }

  ngOnInit() {
    this.conceptService.getList().then(
      concepts => {
        this.concepts = concepts;
      }
    )
    this.conceptCtrl = new UntypedFormControl();
    this.filteredConcepts = this.conceptCtrl.valueChanges
      //.startWith('')
      .pipe(
        map(concept => concept && typeof concept === 'object' ? concept.shortcut : concept),
        map(name => this.filterConcepts(name))
      );

    this.taxes = this.data.taxes;

    // Comentamos esto ya que no esta realizando nada, para la correcta implementacion ver ejemplos de presupuesto
    // this.item = this.data.item;
  }

  displayFn(concept) {
    for (const ct of this.concepts) {
      if (ct.name == concept) {
        this.item.quantity = 1;
        this.item.unityAmount = ct.price;
      }
    }
  }

  onSelectTax(taxId: number): void {
    const taxFinded = this.taxes.find(c => c.id == taxId);

    if (taxFinded) {
      this.setTax(taxFinded, this.item)
    }

  }

  setTax(tax: BailTaxModel, item: BailLineModel) {

    // Nota: Esto es importante añadirlo
    tax.taxId = tax.id;

    if (item.taxes.filter(t => t.type == tax.type).length === 0) {

      item.taxes.push(tax);

    } else {

      if (tax.name.includes("Inversión S.P.") && item.taxes.filter(t => t.name.includes("Inversión S.P.")).length === 0) {

        item.taxes.push(tax);

      } else if (item.taxes.filter(t => t.name.includes("Inversión S.P.")).length !== 0 && tax.name.includes("Inversión S.P.") === false) {

        item.taxes.push(tax);

      } else {

        this.displayInfo('No se puede añadir impuestos del mismo tipo');

      }

    }

  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 3000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  changeChips = function (element: BailFormItemComponent) {
    element.item.taxes.forEach(tax => {
      element.setTax(tax, element.item);
    });
  }

  calcularTotalesLinea(invoiceLine) {
    invoiceLine.totalLine = this.taxCalculator.calcularTotalLinea(invoiceLine);
    return invoiceLine.totalLine;
  }

  onCancel(): void {
    this.dialogRef.close({ action: 'cancel' });
  }

  onSave(): void {
    this.dialogRef.close({ action: 'save', item: this.item });
  }
  public trackByIndex(i: number) { return i; }

}
